import { render, staticRenderFns } from "./TwoFALogin.vue?vue&type=template&id=895700e2&scoped=true"
import script from "./TwoFALogin.vue?vue&type=script&lang=js"
export * from "./TwoFALogin.vue?vue&type=script&lang=js"
import style0 from "./TwoFALogin.vue?vue&type=style&index=0&id=895700e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895700e2",
  null
  
)

export default component.exports